import { C_TEAL, C_AMBER, C_PURPLE, C_STEEL } from '../utils/palette';
import { setupCanvas } from '../utils/canvas';

export const CHART_KEY = [
    'Share of total ranking points earned by round type',
    'Finals contribute most — round multiplier is highest there',
];

const ROUND_COLORS = { 'Final': C_TEAL, 'Semi': C_AMBER, 'Quali': C_PURPLE, 'Pre-Quali': C_STEEL };

/**
 * @param {HTMLCanvasElement} canvas
 * @param {Array} riders
 */
export function renderRoundDonut(canvas, riders) {
    if (!canvas || !riders.length) return;

    const totals = { 'Final': 0, 'Semi': 0, 'Quali': 0, 'Pre-Quali': 0 };
    riders.forEach(r => {
        Object.values(r.entriesByYear || {}).forEach(entries => {
            entries.forEach(e => {
                const rn = (e.round || '').toLowerCase();
                let key = 'Final';
                if (rn.includes('pre'))                                   key = 'Pre-Quali';
                else if (rn.includes('semi'))                             key = 'Semi';
                else if (rn.includes('quali') || rn.includes('qualifier')) key = 'Quali';
                totals[key] += e.pts || 0;
            });
        });
    });

    const entries = Object.entries(totals).filter(([, v]) => v > 0);
    if (!entries.length) return;
    const total = entries.reduce((s, [, v]) => s + v, 0);

    const w   = canvas.parentElement.clientWidth || 280;
    const h   = 140;
    const ctx = setupCanvas(canvas, w, h);
    ctx.clearRect(0, 0, w, h);

    const cx = w * 0.38;
    const cy = h / 2;
    const r  = Math.min(cx, cy) * 0.78;

    let angle = -Math.PI / 2;
    entries.forEach(([label, val]) => {
        const slice = (val / total) * Math.PI * 2;
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.arc(cx, cy, r, angle, angle + slice);
        ctx.closePath();
        ctx.fillStyle   = ROUND_COLORS[label];
        ctx.fill();
        ctx.strokeStyle = '#fff';
        ctx.lineWidth   = 1.5;
        ctx.stroke();
        angle += slice;
    });

    ctx.beginPath();
    ctx.arc(cx, cy, r * 0.55, 0, Math.PI * 2);
    ctx.fillStyle = '#fff';
    ctx.fill();

    const legX = cx + r + 14;
    entries.forEach(([label, val], i) => {
        const pct = Math.round((val / total) * 100);
        const ly  = cy - (entries.length * 15) / 2 + i * 17 + 8;
        ctx.fillStyle = ROUND_COLORS[label];
        ctx.fillRect(legX, ly - 7, 8, 8);
        ctx.fillStyle = '#555';
        ctx.font = '9px sans-serif';
        ctx.textAlign = 'left';
        ctx.fillText(`${label}  ${pct}%`, legX + 12, ly);
    });
}
